import applyMessageActionOperation from 'owa-service/lib/operation/applyMessageActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import applyMessageActionRequest from 'owa-service/lib/factory/applyMessageActionRequest';
import messageAction from 'owa-service/lib/factory/messageAction';
import itemId from 'owa-service/lib/factory/itemId';
/**
 * Restore item service
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage
 */
export default function restoreItemService(itemIds) {
    var requestBody = configureRequestBody(itemIds);
    return applyMessageActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
/**
 * Configure the request body
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage body
 */
function configureRequestBody(itemIds) {
    return applyMessageActionRequest({
        MessageAction: messageAction({
            Action: 'Restore',
        }),
        Ids: itemIds.map(function (itemIdValue) { return itemId({ Id: itemIdValue }); }),
    });
}
//# sourceMappingURL=restoreItemService.js.map